import Vue from 'vue'
import ScenarioPopupApi from '../apis/scenario_popup'
export const state = () => ({
  token: "",
  url: "",
  name: "",
  id: ""
});
export const actions = {
  async copy({ commit, state }) {
    return await ScenarioPopupApi.copy(state)
  },
}
export const mutations = {
  setToken(state, token){
    state.token = token
  },
  setUrl(state, url){
    state.url = url
  },
  setName(state, name){
    state.name = name
  },
  setId(state, id){
    state.id = id
  },
  setSpecificPositionFlag(state, flag){
    state.specific_position_flag = flag
  },
}
export const getters = {}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
